export class AppSettingsBase {
	// App version and build version. Not to be over-write by settings from Firebase
	public appVersion = '1.0.0'
	public iosBuildVersion = 10000;
	public androidBuildVersion = 10000;

	public appName: string = 'Smart App';
	public activePlugins:any = [];
	public adminEmail: string = '';
	public adminURL: string = '';	
	public appURL: string = '';
	public webURL: string = '';
	public commentsPerPage: number = 50;
	public postsPerPage: number = 20;
	public briefMaxChar: number = 200;
	public feedPostMaxChar: number = 350;
	public feedImageDirectory: string = 'feed-images';
	public largeSizeH: number = 1024;
	public largeSizeW: number = 1024;
	public mediumSizeH: number = 500;
	public mediumSizeW: number = 500;
	public thumbSizeH: number = 150;
	public thumbSizeW: number = 150;
	public piwikSiteId: number = 0;
	public piwikURL: string = '';
	public paypalKey: string = '';
	public requireAppUpdate: boolean = false;
	public appDownloadURL:string = '';
	public appUpdateMessage: string = '';
	public requireLogin: boolean = true;
	public topMenuLocation: string = 'left';
	public bottomMenu: boolean = true;
	public allowSignUp: boolean = false;
	public appLogo: string = '';
	public homePage = '';
	public membershipApplicationImageDirectory = 'application';
	public membershipApplicationPaymentImageDirectory = 'membership-payments';
	public TLSAPIDefaultToken = '';
	public TLSAPIKey = '';
	public TLSAPISource = '';
	public TLSAPIUserName = '';
	public TLSAPIPassword = '';
	public TLSAPIUrl = '';
	public TLSAPITestMode = false;
	public TLSCacheTimestamp = "0";
	public elasticSearch:any = {};
	public gMapCenterPointsDefault: any = {};
	public gMapRadius: number = 18;
	public gMapZoom: number = 5;
	public geoCodeUrl: string = 'https://maps.googleapis.com/maps/api/geocode/xml?sensor=false&address=';
	constructor(){
	}
}


// WEBPACK FOOTER //
// ./src/config/app-settings-base.ts